export default __webpack_public_path__ + "static/faillite-avocat-vs-syndic-avantages-35afa7eea29252f6739aa2564dd34b22.jpg";